import { getAPICall, postAPICall } from './BaseAPI';

export const getBikeStandSales = async (payload, cb = (jR, s, e)=>{}) => {
  return await postAPICall('report/getbikestandsalesreport/', payload, cb);
}

export const getTipsReport = async (payload, cb = (jR, s, e)=>{}) => {
  return await postAPICall('report/gettipsreport/', payload, cb);
}

export const setTipPaid = async (payload, cb = (jR, s, e)=>{}) => {
  return await postAPICall('report/settippaid/', payload, cb);
}